import { Action } from 'redux';

import { isUpdateUserSettingsAction } from '../actions/UpdateUserSettingsAction';
import { UserSettingsState } from '../state/UserSettingsState';
import { maybeUpdate } from './ReducerHelpers';

const initialState: UserSettingsState = {};

export function userSettingsReducer(
  userSettingsState: UserSettingsState = initialState,
  action: Action = null
): UserSettingsState {
  if (isUpdateUserSettingsAction(action)) {
    const newDomain = maybeUpdate(userSettingsState[action.domain],
      action.username, action.userSettings
    );
    return maybeUpdate(userSettingsState,
      action.domain, newDomain
    );
  } else {
    return userSettingsState;
  }
}
